module.exports = __webpack_public_path__ + "img/powerGrid-icon_3.893c4fff.png";